import { render } from "./Backend.vue?vue&type=template&id=05d4af55&scoped=true"
import script from "./Backend.vue?vue&type=script&lang=js"
export * from "./Backend.vue?vue&type=script&lang=js"

import "./Backend.vue?vue&type=style&index=0&id=05d4af55&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d4af55"]])

export default __exports__